import { render } from "./issue.vue?vue&type=template&id=47869a86&scoped=true"
import script from "./issue.vue?vue&type=script&lang=js"
export * from "./issue.vue?vue&type=script&lang=js"

import "./issue.vue?vue&type=style&index=0&id=47869a86&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-47869a86"

export default script